import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { isVmsAuthenticated, isVmsFirstTimeLogin } from "../utils/auth";

const VmsProtectedRoute = () => {
  const location = useLocation();

  if (!isVmsAuthenticated()) {
    return <Navigate to="/vms/login" replace state={{ from: location }} />;
  }

  const isOnChangePasswordPage = location.pathname === "/vms/change-password";
  if (isVmsFirstTimeLogin() && !isOnChangePasswordPage) {
    return <Navigate to="/vms/change-password" replace />;
  }

  return <Outlet />;
};

export default VmsProtectedRoute;
